"use client";
import React from "react";
import dynamic from "next/dynamic";
import Footer from "../components/Footer/page.js";
import MainHeader from "@/components/MainHeader/MainHeader.js";
const Header = dynamic(() => import("../components/Header/page.js"), {
  ssr: false,
});

const page = () => {
  return (
    <div>
      <div>
        <MainHeader />
        <section className="section-spacing">
          <div className="container">
            <div className="m-auto about-hero">
              <h1 className="text-center text-white">Privacy Policy</h1>
            </div>
          </div>
        </section>
      </div>
      <div className="container my-5 privacy-container privacy-margin">
        <div className="privacy-wrapper">
          {/* <h1 className="display-4 text-primary mb-3 privacy-title">Privacy Policy</h1> */}
          {/* <p className="privacy-date">
                        Effective Date: 19 Dec 2024 | Last Updated: 19 Dec 2024
                    </p> */}

          <section className="mb-4 privacy-section">
            <h2 className="privacy-heading">Introduction</h2>
            <p className="privacy-para">
              OneStop is committed to protecting your privacy and safeguarding
              your information. This policy describes how we collect, use, and
              secure your personal information.
            </p>
          </section>

          <section className="mb-4 privacy-section">
            <h2 className="h4 text-dark privacy-heading">
              1. Information We Collect
            </h2>
            <ul className="list-unstyled">
              <li className="privacy-para mb-2">
                <strong>Personal Data:</strong> Includes name, contact details,
                payment information, and service preferences.
              </li>
              <li className="privacy-para mb-2">
                <strong>Usage Data:</strong> IP address, device type, and other
                app usage metrics.
              </li>
              <li className="privacy-para mb-2">
                <strong>Location Data:</strong> Collected with user consent to
                connect customers with nearby vendors.
              </li>
            </ul>
          </section>

          <section className="mb-4 privacy-section">
            <h2 className="h4 text-dark privacy-heading">
              2. How We Use Your Information
            </h2>
            <ul className="list-unstyled">
              <li className="privacy-para mb-2">
                <strong>Service Improvement:</strong> To enhance app
                functionality and user experience.
              </li>
              <li className="privacy-para mb-2">
                <strong>Communication:</strong> For notifications regarding
                account updates or policy changes.
              </li>
            </ul>
          </section>

          <section className="mb-4 privacy-section">
            <h2 className="h4 text-dark privacy-heading">3. Data Sharing</h2>
            <ul className="list-unstyled">
              <li className="privacy-para mb-2">
                <strong>With Vendors:</strong> Shared for the purpose of
                fulfilling bookings.
              </li>
              <li className="privacy-para mb-2">
                <strong>Third-Party Service Providers:</strong> Data may be
                shared with providers like payment processors.
              </li>
              <li className="privacy-para mb-2">
                <strong>Legal Compliance:</strong> Shared as necessary to comply
                with applicable laws.
              </li>
            </ul>
          </section>

          <section className="mb-4 privacy-section">
            <h2 className="h4 text-dark privacy-heading">4. User Rights</h2>
            <p className="privacy-para">
              You may access, correct, or request deletion of your data, subject
              to our legal obligations.
            </p>
          </section>

          <section className="mb-4 privacy-section">
            <h2 className="h4 text-dark privacy-heading">5. Data Security</h2>
            <p className="privacy-para">
              We employ encryption and other measures to protect data, but users
              assume risk when transmitting data online.
            </p>
          </section>

          <section className="mb-4 privacy-section">
            <h2 className="h4 text-dark privacy-heading">
              6. Anti-Copying and Data Protection
            </h2>
            <p className="privacy-para">
              <strong>Proprietary Information:</strong> OneStop’s data,
              structure, and customer information are proprietary. Users and
              vendors are prohibited from copying, distributing, or misusing any
              data gained through the platform.
            </p>
          </section>

          <section className="mb-4 privacy-section">
            <h2 className="h4 text-dark privacy-heading">
              7. Changes to Policy
            </h2>
            <p className="privacy-para">
              We may update this policy periodically. Changes are effective upon
              posting.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="h4 text-dark privacy-heading">
              8. How to Contact Us
            </h2>
            <p className="privacy-para">
              If you have any questions about our Privacy Policies, feel free to
              contact us:
            </p>
            <p className="privacy-para">
              Email:{" "}
              <a
                href="mailto:contact@itsonlyonestop.com"
                className="text-decoration-none"
              >
                contact@itsonlyonestop.com
              </a>
            </p>
          </section>
        </div>
        {/* <footer className="mt-5 pt-3 border-top text-center text-muted terms-footer">
                    &copy; 2024 OneStop. All Rights Reserved.
                </footer> */}
      </div>
    </div>
  );
};

export default page;
